import React from 'react';
export default function LoginScreen() {
    return <div>Login screen placeholder</div>;
  }
  